import { InternalUser } from '../../models';
import { CreateInternalUserRequest } from '../../../../web-api-client';

export const mapInternalUserToCreateRequest = (
  user: InternalUser
): CreateInternalUserRequest => {
  return new CreateInternalUserRequest({
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    isActive: user.isActive,
  });
};
